// Central company configuration — edit these values to update across the site.
export const COMPANY = {
  name: 'Flow Fleet Solutions',
  phoneDisplay: '(314) 699-4266',
  phoneHref: 'tel:+13146994266',
  email: 'flowfleetsolutions@gmail.com',
  siteUrl: 'https://dispatch-optimizer-9.emergent.host',
  primaryAreas: ['Florida', 'Miami-Dade County', 'Broward County', 'Palm Beach County'],
  secondaryAreas: ['Southeast United States', 'Nationwide Dispatch Services'],
  tagline: 'Truck Dispatch Services for Owner Operators & Fleets',
};
